module.exports = __webpack_public_path__ + "static/img/time.809df2f6.svg";